import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, take } from "rxjs/operators";

import { fetchHomepageStory, fetchStory } from "../actions/story.action";
import { StoryState } from "../reducers/story.reducer";
import { selectStoryLoading } from "../selectors/story.selectors";

@Injectable()
export class StoryFacade {
    private storyStore = inject<Store<StoryState>>(Store);

    public fetchStory(path: string, searchTerm: string | undefined): void {
        this.storyStore.dispatch(fetchStory({ path, searchTerm }));
    }

    public fetchHomepageStory(): void {
        this.storyStore.dispatch(fetchHomepageStory());
    }

    /**
     * Return loading state only when loading false
     */
    public selectLoadingWhenFalse(): Observable<boolean> {
        return this.storyStore.select(selectStoryLoading).pipe(
            filter((loading) => !loading),
            take(1),
        );
    }
}
